import { login } from '../../store/Auth/auth.actions';

import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Button from 'material-ui/Button';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import { connect } from 'react-redux';

const loginStyle = {
  card: {
    minWidth: 300,
  },
  input: {
    width: '100%',
  },
  header: {
    height: 197,
    width: '100%',
    backgroundColor: '#253238',
  },
};

interface OwnProps extends RouteComponentProps<{}> {
  classes: {
    card: React.AbstractView;
    input: React.AbstractView;
    header: React.AbstractView;
  };
}

interface State {
  username: string;
  password: string;
}

type Props = OwnProps & typeof mapDispatch;

class Login extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  private onLoginBtnClick = () => {
    const { onLoginBtnClick } = this.props;
    const { username, password } = this.state;
    onLoginBtnClick({
      username,
      password,
    });
  };

  private onUsernameChange = (e: { target: HTMLInputElement }) => {
    this.setState({
      username: e.target.value,
    });
  };

  private onPasswordChange = (e: { target: HTMLInputElement }) => {
    this.setState({
      password: e.target.value,
    });
  };

  private keyPressed = (event: any) => {
    if (event.key !== 'Enter') {
      return;
    }

    this.onLoginBtnClick();
  };

  public render() {
    const { classes } = this.props;

    return (
      <Grid
        container={true}
        alignItems="center"
        justify="center"
        direction="column"
        style={{ width: '100vw', height: '100vh' }}
        onKeyDown={this.keyPressed}
      >
        <Grid item={true}>
          <Card className={classes.card}>
            <CardContent className={classes.header}>
              <Grid
                container={true}
                alignItems="flex-end"
                style={{ height: '100%' }}
              >
                <Grid item={true}>
                  <Typography type="headline" component="h1">
                    Login
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent>
              <Grid container={true} direction="column" alignItems="stretch">
                <Grid item={true}>
                  <TextField
                    onChange={this.onUsernameChange}
                    label="User name"
                    className={classes.input}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    type={'password'}
                    onChange={this.onPasswordChange}
                    label="Password"
                    className={classes.input}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid container={true} justify="flex-end">
                <Button onClick={this.onLoginBtnClick}>Log in</Button>
              </Grid>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

const mapDispatch = {
  onLoginBtnClick: login,
};

export default withStyles(loginStyle)(
  connect(
    undefined,
    mapDispatch
  )(Login)
);



// WEBPACK FOOTER //
// ./src/modules/Login/index.tsx